<app-react-wrapper [content]="this.article?.content || {}"></app-react-wrapper>
